import ProductCard from '../components/ProductCard'
import { useProductsContext } from '../../hooks/useProductsContext'

export default function Products() {

  const {products} = useProductsContext()

  
  const menProducts = products && products.filter(product=> product.category ==="men")
  const womenProducts = products &&  products.filter(product=> product.category ==="women")
  const accessoriesProducts = products &&  products.filter(product=> product.category ==="accessories")

  return (
    <>
    {/* 
        Integrate stripe
        Create user authentication 
     
        User orders goes into database
        Show them in admin panel */}
   
      {/* Mixed products */}

  <h1 style={{textAlign:"center"}}>Men </h1>
    <div className='products--container'>
      
        { menProducts && menProducts.map((product) => (
            <ProductCard key={product._id} product={product} />
        )) }
     
    </div> <br /><br /> <br />
    <h1 style={{textAlign:"center"}}> Women </h1>
    <div className='products--container'>
     
        { womenProducts && womenProducts.map((product) => (
            <ProductCard key={product._id} product={product} />
        )) }
     
    </div> <br /><br /> <br />
    <h1  style={{textAlign:"center"}}> Accessories</h1>  
    <div className='products--container'>
    
        { accessoriesProducts && accessoriesProducts.map((product) => (
            <ProductCard key={product._id} product={product} />
        )) }
     
    </div>

    </>
  )
}
